import { BaseController } from '../../common/base/controller';

export class CustomerConfirmController extends BaseController {
  constructor(controllerService, confirmStateName) {
    'ngInject';
    super({ controllerService, confirmStateName });
  }

  resolved(data, response) {
    const user = this.userService.get();
    if (user && user.requestId) {
      this.go(this.confirmStateName, { ticketId: user.requestId });
    }
  }
}
